import { Navigate, Route, Routes } from 'react-router-dom';
import { LoginPage } from './pages/LoginPage';
import { AppShell } from './layout/AppShell';
import { RequireAuth } from './auth/RequireAuth';
import { RequireRole } from './auth/RequireRole';
import { DashboardPage } from './pages/DashboardPage';
import { AreaPage } from './pages/AreaPage';
import { RunsHealthPage } from './pages/runs/RunsHealthPage';
import { ContentRadarPage } from './pages/content/ContentRadarPage';
import { MetaAdsPage } from './pages/meta/MetaAdsPage';
import { UsersAdminPage } from './pages/admin/UsersAdminPage';
import { MyOkrPage } from './pages/okr/MyOkrPage';
import { TeamOkrPage } from './pages/okr/TeamOkrPage';
import { PeopleOkrPage } from './pages/okr/PeopleOkrPage';
import { InstructionsPage } from './pages/InstructionsPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { useAuth } from './auth/useAuth';

function RunsHealthRoute() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role !== 'admin' && !user.tabs.includes('runs-health')) {
    return <Navigate to="/dashboard" replace />;
  }
  return <RunsHealthPage />;
}

function ContentRadarRoute() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role !== 'admin' && !user.tabs.includes('content-radar')) {
    return <Navigate to="/dashboard" replace />;
  }
  return <ContentRadarPage />;
}

function MetaAdsRoute() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role !== 'admin' && !user.tabs.includes('meta-ads')) {
    return <Navigate to="/dashboard" replace />;
  }
  return <MetaAdsPage />;
}

function TeamOkrRoute() {
  const { user } = useAuth();
  if (!user) return null;
  if (!user.isManager) {
    return <Navigate to="/okrs" replace />;
  }
  return <TeamOkrPage />;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<RequireAuth />}>
        <Route element={<AppShell />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/dashboard/runs-health" element={<RunsHealthRoute />} />
          <Route path="/content-radar" element={<ContentRadarRoute />} />
          <Route path="/meta-ads" element={<MetaAdsRoute />} />
          <Route path="/dashboard/:layerSlug/:areaSlug" element={<AreaPage />} />

          <Route path="/okrs" element={<MyOkrPage />} />
          <Route path="/okrs/all" element={<PeopleOkrPage />} />
          <Route path="/okrs/team" element={<TeamOkrRoute />} />

          <Route path="/instructions" element={<InstructionsPage />} />

          <Route element={<RequireRole roles={['admin']} />}>
            <Route path="/admin/users" element={<UsersAdminPage />} />
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
    </Routes>
  );
}
